import { Link, useParams } from "react-router-dom"
import PerfectScrollbar from 'react-perfect-scrollbar'
import sanitizeHtml from 'sanitize-html';
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Note from "../model/Note";
import notesApi from "../api/NotesApi";
import { setCurrentNoteId } from "../../../store/NotesStore";
import { RootState } from "../../../store/store";
import { toggleOpenMainSideBar } from "../../core/functions";
import { isMobile } from "react-device-detect";
import moment from "moment";
import NotesByRow from "./NotesByRow";

type Params = {
    categoryId: string|undefined;
    noteId: string|undefined;
}

type Pageable = {
    totalElements: number,
    totalPages: number,
}

const NotesList = () => {
    const dispatch = useDispatch();

    const { noteId } = useParams<Params>();   
    const [notes, setNotes] = useState<Note[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageable, setPageable] = useState<Pageable>({totalElements: 0, totalPages: 0});
    const filter = useSelector((state: RootState) => state.notes.filter);
    const [deviceWidth, setDeviceWidthWidth] = useState<number>(window.innerWidth);

    const handleWindowSizeChange = () => {
        setDeviceWidthWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobileView = deviceWidth <= 768;

    const selectCurrentNote = useCallback((noteId:any) => {
        dispatch(setCurrentNoteId(noteId));
    }, [dispatch]);
    
    const loadNotesCallBack = useCallback(() => {
        var params = {};
        if (filter && "categoryId" in filter) {
            let categoryId = filter["categoryId"];
            params = {...params, categoryId};
        }
        if (filter && "tagId" in filter) {
            let tagId = filter["tagId"];
            params = {...params, tagId};
        }
        notesApi.getNotes(params, page)
            .then((data) => {
                setNotes(data.content);
                setPageable({totalElements: data.totalElements, totalPages: data.totalPages})
            })
    }, [filter, page])

    useEffect(() => {
        loadNotesCallBack();
    }, [loadNotesCallBack])

    useEffect(() => {
        if (noteId) {
            selectCurrentNote(noteId);
        }
        else if (notes && notes.length > 0) {
            var n:Note = notes[0];
            if (n.id !== undefined) {
                selectCurrentNote(n.id!);
            }
        }
    }, [selectCurrentNote, noteId, notes]);

    const nextPage = () => {
        setPage(page + 1);
    }

    const prevPage = () => {
        if (page > 0 ) {
            setPage(page - 1);
        }        
    }

    const onSelectNote = (note: Note) => {
        if (isMobile || isMobileView) {
            toggleOpenMainSideBar(undefined);
        }
        return true;
    }

    const toggleFavorites = (noteId: number, favorites: boolean) => {
        return false;
        // NotesApi.setNoteFavorites(noteId, favorites)
        //     .then(() => {
        //         setNote({...note, favorites});
        //     })
    }

    return (
        <>
            <div className="layer w-100">
                <div className="bgc-grey-100 _peers ai-c jc-sb p-20 fxw-nw">                    
                    <div className="_peer d-flex justify-content-between">                        
                        <div className="m-0 btn-group" role="group">
                            <button type="button" className={`fsz-xs btn bgc-white bdrs-2 mR-3 cur-p ${page > 0 ? '' : 'd-none'}`}
                                onClick={prevPage}>
                                    <i className="ti-angle-left"></i>
                            </button>
                            <button type="button" className={`fsz-xs btn bgc-white bdrs-2 mR-3 cur-p ${page >= pageable.totalPages ? '' : 'd-none'}`}
                                onClick={nextPage}>
                                    <i className="ti-angle-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <PerfectScrollbar className="layer w-100 fxg-1 pos-r">
                <NotesByRow notes={notes}/>
            </PerfectScrollbar>
        </>
    )
}

export default NotesList;